import { useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './css/App.css';
import { DContext } from './store/DataContext';
import Router from './Router';
import Header from './layouts/Header';
import Footer from './layouts/Footer';

function App() {

  const { popup, handlePopupConfirm, handlePopupCancel } = useContext(DContext)
  const dialogRef = useRef()
  const location = useLocation();

  useEffect(() => {
    if (popup.visible) {
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
    }
  }, [popup.visible])

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <div className="">
      <Header />
      <Router />
      <Footer />

      {/* 🔔 Global Popup Dialog */}
      <dialog
        ref={dialogRef}
        className="rounded-lg p-6 max-w-md w-full backdrop:bg-black/30 bg-white shadow-xl"
      >
        <p className="text-gray-800 mb-4 text-base">{popup.message}</p>

        {popup.type === "alert" && (
          <div className="text-center">
            <button
              onClick={handlePopupConfirm}
              className="px-5 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md"
            >
              OK
            </button>
          </div>
        )}

        {popup.type === "confirm" && (
          <div className="flex justify-end gap-4">
            <button
              onClick={handlePopupCancel}
              className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded"
            >
              Cancel
            </button>
            <button
              onClick={handlePopupConfirm}
              className="px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded"
            >
              OK
            </button>
          </div>
        )}

        {popup.type === "delete" && (
          <div className="flex justify-end gap-4">
            <button
              onClick={handlePopupCancel}
              className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded"
            >
              Cancel
            </button>
            <button
              onClick={handlePopupConfirm}
              className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded"
            >
              Delete
            </button>
          </div>
        )}
      </dialog>
    </div>
  );
}

export default App;
